'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  config = require('../../js/config'),
  ShowHide = require('../../js/components/ShowHide'),
  cacheCookieHelper = require('../../components/CacheCookieHelper/CacheCookieHelper'),
  CurrencyDropdownView = require('./js/CurrencyDropdownView'),
  LanguageDropdownItemView = require('./js/LanguageDropdownItemView'),
  RegionsDropdownView = require('./js/RegionsDropdownView'),
  MinimalHeaderView = require('./js/MinimalHeaderView'),
  DivisionMenuView = require('./js/DivisionMenuView'),
  MyArrowTM = require('./js/MyArrowTM'),
  HeaderSearchView = require('./js/HeaderSearchView'),
  MyArrowUserNotificationBar = require('./js/MyArrowUserNotificationView').default,
  $global = require('../../js/globalElements'),
  mediator = require('../../js/mediator'),
  cookies = require('js-cookie'),
  breakpoints = require('../../js/breakpoints'),
  personalizedInfo = null,
  currency = null,
  language = null,
  userIsLoggedIn = null;

import userService from '../../services/CartUserService';
import { MinimisedHeaderView } from './js/MinimisedHeaderView';
import { AccountLinksView } from './js/AccountLinksView';
import templateLanguageElementCreate from './templates/_LanguageElementCreate.hbs';
import utilities from '../../js/utilities';
import { pluraliseAndTranslate } from '../../utilities/globalisation';
import Analytics from '../Analytics/Analytics';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';

let headerInstance;
const DROPDOWN_CLASSES = `${config.classes.hasHeaderDropdown} ${config.classes.hasAccountDropdown}`;

export class Header {

  initialize() {
    // get from new cookie set in login
    userIsLoggedIn = window.Arrow.isAuthorized;

    // if the header caching is enabled, get/set personalized data
    this.setPersonalizedData().then((data) => {
      this.initializePersonalizedComponents(data);
    });

    // Setting up the MyArrowTM to handle the user based on user type
    let model = new Backbone.Model({ isMyArrowUser: false, isFromLogin: this.isFromLogin() });

    if (userIsLoggedIn) {
      userService.isMyArrowUser().then((isMyArrowUser) => {
        model.set('isMyArrowUser', isMyArrowUser);
        // Only initialize if they are a myarrowuser
        if (isMyArrowUser) {
          this.initializeRegionsDropdown();
          if (MyArrowUserNotificationBar.shouldDisplay()) {
            new MyArrowUserNotificationBar({ model: model, el: $global.$body.find('#MyArrowUserNotification') });
          }
        }
        new MyArrowTM({ model: model, el: $global.$head });
      });
    } else {
      // Can't be a MyArrow user if not logged in
      new MyArrowTM({ model: model, el: $global.$head });
    }

    // We need these asap but release the thread so
    // the rest of initialize can be setup quickly
    _.delay(() => {
      new HeaderSearchView({ el: '.Header-search' });
      new MinimalHeaderView({ el: $global.$head });
      new MinimisedHeaderView({ el: document.getElementById('page-header') });
    });
    _.delay(() => {
      new RegionsDropdownView({ el: '.HeaderDd-regions' });
    });

    new DivisionMenuView({ el: $global.$head });
    this.initializeElements();
    this.initializeShowHides();
    this.initializeOverlayClickHandler();
    this.initializeWindowScrollHandler();
    this.initializeCartClickHandler();
  }

  initializePersonalizedComponents(personalizedData) {
    new CurrencyDropdownView({ el: '.HeaderDd-currency', model: { personalizedData: personalizedData } });
    new LanguageDropdownItemView({ el: '.HeaderDd--language', model: { personalizedData: personalizedData } });
    new AccountLinksView({
      el: '.account-links', model: {
        personalizedData: personalizedData,
        isUserLoggedIn: userIsLoggedIn
      }
    });
  }

  initializeRegionsDropdown() {
    this.$regionsEl = this.$el.find('.Header-nav-inner--regions-dropdown');
    this.$regionsDropdown = this.$el.find('a.js-regions-dropdown');

    new ShowHide({
      el: this.$regionsEl,
      type: this.$regionsDropdown,
      group: this.headerGroup,
      activeBodyClass: config.classes.hasHeaderDropdown,
      activeClass: 'regions-open',
      onShow: () => { this.toggleDropdownArrow(this.$regionsEl, true); },
      onHide: () => { this.toggleDropdownArrow(this.$regionsEl, false); },
      animation: 'slide'
    });
  }

  initializeElements() {
    this.$el = $global.$head;
    this.$hamburger = this.$el.find('.Hamburger');
    this.$hamburgerIconBox = this.$hamburger.find('.hamburger-box');
    this.$hamburgerToggleEl = this.$hamburger.find('a.js-HamburgerToggle');
    this.$languageEl = this.$el.find('.Header-nav-inner--language-dropdown');
    this.$languageDropdown = this.$el.find('a.js-language-dropdown');
    this.$currencyEl = this.$el.find('.Header-nav-inner-dropdown-currency');
    this.$currencyMenu = this.$el.find('#menuItemBlockCurrency');
    this.$languageMenu = this.$el.find('#menuItemBlockLanguage');
    this.$languageMenuClient = this.$el.find('#menuItemLanguageClient');
    this.$currencyDropdown = this.$el.find('a.js-currency-dropdown');
    this.$languageList = this.$el.find('ul.linkList li a');
    this.$currencyList = this.$el.find('ul.HeaderDd-list-column li a');
    this.$accountMenuEl = this.$el.find('.Header-nav-inner--accountMenu-dropdown');
    this.$accountMenuDropdown = this.$el.find('a.js-accountMenu-dropdown');
    this.$overlay = $('#overlay-headerDropdown');
    this.$elHeaderTopBar = $('#HeaderTopBar');
    this.$closeButton = $('.HeaderTopBar-close');
    this.$closeButton.click(() => { this.hideBanner() });
    this.$mobileViewData = this.$elHeaderTopBar.find('.HeaderTopBar-mobile');
    this.$desktopViewData = this.$elHeaderTopBar.find('.HeaderTopBar-desktop');
    this.$mobileViewData.click((event) => { this.pushPromoAnalyticsData(event) });
    this.$desktopViewData.click((event) => { this.pushPromoAnalyticsData(event) });
    this.analyticsData = this.$closeButton.data('analytics');
    if (EnableAdobeAnalytics.isEnabled() && this.$desktopViewData[0] && this.$mobileViewData[0]) {
      let headerBannerExist = this.$desktopViewData[0].classList.contains('HeaderTopBar-desktop') && this.$mobileViewData[0].classList.contains('HeaderTopBar-mobile');
      if (headerBannerExist && !this.analyticsData.PromotionId.toLowerCase().includes('maintenance')) {
        Analytics.adobeInternalCampaignView(this.analyticsData.PromotionName);
      }
    }
    this.redirectUrl = this.$mobileViewData.data('redirectUrl');
    this.redirectTarget = this.$mobileViewData.data('redirectTarget');
    this.headerGroup = 'Header';
    this.$focusableInNav = $('#Hamburger-Box [href], #Mobile-Navigation [href],#Mobile-Navigation [tabindex]:not([tabindex="-1"])');
    this.$firstFocusableElement = null;
    this.$lastFocusableElement = null;
    this.nextIndex1 = 0;
    this.nextIndex = 0;
    this.$hamburgerToggleEl.on('keydown',(e)=>{
      if (e.keyCode === 32) {
        e.preventDefault();
        this.$hamburgerToggleEl.click();
      }
    });
    this.$currencyMenu.on('keydown', (e) => {
      if (e.keyCode === 38) {
        // up arrow
        e.preventDefault();
        if (this.$currencyList.length !== 0) {
          this.nextIndex1 === 0 ? this.nextIndex1 = ((this.$currencyList.length / 2) - 1) : this.nextIndex1--;
          this.$currencyList[this.nextIndex1].focus();
        }
      } else if (e.keyCode === 40) {
        // down arrow
        e.preventDefault();
        if (this.$currencyList.length !== 0) {
          this.nextIndex1 === ((this.$currencyList.length / 2) - 1) ? this.nextIndex1 = 0 : this.nextIndex1++;
          this.$currencyList[this.nextIndex1].focus();
        }
      }
    });
    this.$languageMenu.on('keydown', (e) => {
      if (e.keyCode === 38) {
        // up arrow
        e.preventDefault();
        if (this.$languageList.length !== 0) {
          this.nextIndex === 0 ? this.nextIndex = ((this.$languageList.length / 2) - 1) : this.nextIndex--;
          this.$languageList[this.nextIndex].focus();
        }
      } else if (e.keyCode === 40) {
        // down arrow
        e.preventDefault();
        if (this.$languageList.length !== 0) {
          this.nextIndex === ((this.$languageList.length / 2) - 1) ? this.nextIndex = 0 : this.nextIndex++;
          this.$languageList[this.nextIndex].focus();
        }
      }
    });
    this.$languageMenuClient.on('keydown', (e) => {
      if (e.keyCode === 38) {
        // up arrow
        e.preventDefault();
        if (this.$languageList.length !== 0) {
          this.nextIndex === 0 ? this.nextIndex = ((this.$languageList.length / 2) - 1) : this.nextIndex--;
          this.$languageList[this.nextIndex].focus();
        }
      } else if (e.keyCode === 40) {
        // down arrow
        e.preventDefault();
        if (this.$languageList.length !== 0) {
          this.nextIndex === ((this.$languageList.length / 2) - 1) ? this.nextIndex = 0 : this.nextIndex++;
          this.$languageList[this.nextIndex].focus();
        }
      }
    });
    if ($global.$window.outerWidth() < config.breakpoints.laptop) {
      $('.Content-wrapper').css({ paddingTop: $global.$head.outerHeight() });
    }
  }

  initializeShowHides() {

    new ShowHide({
      el: this.$languageEl,
      type: this.$languageDropdown,
      group: this.headerGroup,
      activeBodyClass: config.classes.hasHeaderDropdown,
      activeClass: 'language-open',
      onShow: () => {
        this.renderLanguages();
        this.setAriaExpanded(this.$languageDropdown, true);
      },
      onHide: () => {
        this.toggleDropdownArrow(this.$languageEl, false);
        this.setAriaExpanded(this.$languageDropdown, false);
        this.nextIndex = 0;
      },
      animation: 'slide'
    });

    new ShowHide({
      el: this.$currencyEl,
      type: this.$currencyDropdown,
      group: this.headerGroup,
      activeBodyClass: config.classes.hasHeaderDropdown,
      activeClass: 'currency-open',
      onShow: () => {
        this.toggleDropdownArrow(this.$currencyEl, true);
        this.setAriaExpanded(this.$currencyDropdown, true);
        if (this.$currencyEl && this.$currencyEl.length) {
          let $elements = this.$currencyEl.find('ul.HeaderDd-list-column li a');
          if ($elements.length) {
            $elements.first().focus();
          }
        }
      },
      onHide: () => {
        this.toggleDropdownArrow(this.$currencyEl, false);
        this.setAriaExpanded(this.$currencyDropdown, false);
        this.nextIndex1 = 0;
      },
      animation: 'slide'
    });

    new ShowHide({
      el: this.$accountMenuEl,
      type: this.$accountMenuDropdown,
      group: this.headerGroup,
      activeBodyClass: config.classes.hasHeaderDropdown,
      activeClass: 'accountMenu-open',
      onShow: () => { this.toggleDropdownArrow(this.$accountMenuEl, true); },
      onHide: () => { this.toggleDropdownArrow(this.$accountMenuEl, false); },
      animation: 'slide'
    });

    new ShowHide({
      el: this.$hamburger,
      type: this.$hamburgerToggleEl,
      activeBodyClass: config.classes.hasHeaderDropdown, // Needed for toggle overlay on mobile
      onShow: this.toggleHamburger.bind(this),
      onHide: this.toggleHamburger.bind(this),
      animation: 'fade'
    });
  }

  setAriaExpanded($el, val) {
    for (let i = 0 ;i < $el.length;i++) {
      $el[i].setAttribute('aria-expanded', val);
    }
  }

  renderLanguages() {
    let $jsonElement = this.$el.find('.AvailableLanguagesJson');
    if ($jsonElement.length && Arrow.renderLanguagesClientSide === true) {
      let $list = this.$el.find('.linkList');
      let languageMenuContent = $.parseJSON($jsonElement[0].innerHTML.toString());
      $list.html(templateLanguageElementCreate({
        listElements: languageMenuContent[0]
      }));
      setTimeout(() => {
        this.toggleDropdownArrow(this.$languageEl, true);
        if (this.$languageEl && this.$languageEl.length) {
          let $elements = this.$languageEl.find('ul.linkList li a');
          if ($elements.length) {
            $elements.first().focus();
          }
        }
      }, 250);
    } else {
      this.toggleDropdownArrow(this.$languageEl, true);
      if (this.$languageEl && this.$languageEl.length) {
        let $elements = this.$languageEl.find('ul.linkList li a');
        if ($elements.length) {
          $elements.first().focus();
        }
      }
    }

  }

  hideBanner() {
    this.$elHeaderTopBar.slideUp(function() {
      if ($global.$window.outerWidth() < config.breakpoints.laptop) {
        $('.Content-wrapper').css({ paddingTop: $global.$head.outerHeight() });
        let top = $('.head').height();
        $('#RemovedItemsNotificationBar').css('top', top + 'px');
      }
    });
    cookies.set(config.cookies.headerTopBarDismissed, new Date().toUTCString(), { expires: config.cookies.headerTopBarCookieExpiration });
    if (cacheCookieHelper) {
      cacheCookieHelper.setCacheCookie();
    }
    $global.$body.removeClass('has-headerTopBar-visible');
  }

  pushPromoAnalyticsData(e) {
    e.preventDefault();
    if (this.analyticsData) {
      let promoData = {
        event: config.analytics.eventTypes.PromoClick,
        id: this.analyticsData.PromotionId,
        name: this.analyticsData.PromotionName,
        creative: this.analyticsData.PromotionCreative,
        position: this.analyticsData.PromotionPosition
      }
      if (EnableAdobeAnalytics.isEnabled() && !this.analyticsData.PromotionId.toLowerCase().includes('maintenance')) {
        Analytics.adobeInternalCampaignClick(this.analyticsData.PromotionName);
      } else {
        Analytics.pushToECommercePromotionalEventFramework(promoData);
      }
    }
    window.open(this.redirectUrl, this.redirectTarget);
  }

  toggleHamburger() {
    $global.$body.toggleClass('HamburgerMenu--open');

    if ($global.$body.hasClass('HamburgerMenu--open')) {
      this.saveScrollTop = $global.$body.scrollTop();
    }
    else {
      $global.$body.scrollTop(this.saveScrollTop);
    }
    this.$hamburgerIconBox.toggleClass('cross-box');
    this.$hamburgerToggleEl.toggleClass('Icon--hamburger').toggleClass('Icon--cross');
    if (this.$focusableInNav.length) {
      this.$firstFocusableElement = this.$focusableInNav.first();
      this.$lastFocusableElement = this.$focusableInNav.last();
    }
    this.$firstFocusableElement.on('keydown', (e) => {
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastFocusableElement.focus();
      }
    });
    this.$lastFocusableElement.on('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstFocusableElement.focus();
      }
    });
    let ariaLabelVal = 'menu';
    if (this.$hamburgerToggleEl.hasClass('Icon--cross')) {
      ariaLabelVal = 'Close';
    }
    this.$hamburgerToggleEl.attr('aria-label',ariaLabelVal);
  }

  initializeOverlayClickHandler() {

    let $els = [this.$overlay, $global.$head];

    $els.forEach(function($el) {
      $el.on('click', function(e) {
        var $targetEl = $(e.target);
        // Check to see if we clicked in the header / inside the drop down, if not go ahead and close it
        if (!$targetEl.parents('[data-header-dropdown]').length) {
          $global.$body.removeClass(DROPDOWN_CLASSES);
          mediator.trigger(config.events.showHide.hideGroupHeader, {});
        }
      });
    });
  }

  initializeCartClickHandler() {
    mediator.on(config.events.header.openingDropdownView, (vw) => {
      // TODO: Remove logic if mini cart gets moved to ShowHide.
      // TechDebt: ARW-4398
      if (vw.$cart) {
        $global.$body.removeClass(config.classes.hasHeaderDropdown);
        mediator.trigger(config.events.showHide.hideGroupHeader, {});
      }
    });
  }

  toggleDropdownArrow($el, openDropdown) {
    if (openDropdown) {
      $el.addClass('arrow-up');
      if (this.isAccountMenuOpen($el)) {
        $global.$body.addClass(config.classes.hasAccountDropdown);
      }

      mediator.trigger(config.events.header.openingDropdownView, this);
      $el.on('keydown', (e)=>{
        if (e.key === 'Escape') {
          e.preventDefault();
          $el.removeClass('arrow-up');
          if (this.isAccountMenuOpen($el)) {
            $global.$body.removeClass(config.classes.hasAccountDropdown);
          }
          $global.$body.removeClass(DROPDOWN_CLASSES);
          mediator.trigger(config.events.showHide.hideGroupHeader, {});
          $el.find('a.Header-navBar-list--block').focus();
        }
      });
    } else {
      $el.removeClass('arrow-up');
      if (this.isAccountMenuOpen($el)) {
        $global.$body.removeClass(config.classes.hasAccountDropdown);
      }
    }
  }

  initializeWindowScrollHandler() {
    mediator.on(config.events.ui.scrollThrottle, () => {
      //Check if any dropdown is open in the header, if not go ahead and close it
      // stopScollingEventOnFocus flag used to solve ARW-34718 Search Bar is disappearing when click on search button in footer
      if (this.isHeaderDropdownOpen() && !config.analytics.flags.stopScollingEventOnFocus) {
        $global.$body.removeClass(DROPDOWN_CLASSES);
        mediator.trigger(config.events.showHide.hideGroupHeader, {});
      }
    });
  }

  isHeaderDropdownOpen() {
    return $global.$body.hasClass(config.classes.hasHeaderDropdown);
  }

  isAccountMenuOpen($el) {
    return $el === this.$accountMenuEl && breakpoints.isGreaterThan(config.breakpoint.laptop, true)
  }

  isFromLogin() {
    let isFromLogin = cookies.get(config.cookies.fromLogin) === '1';

    // Need to set this cookie to zero after login so it doesn't read incorrectly on other pages.
    cookies.set(config.cookies.fromLogin, '0', { domain: config.cookies.domain });

    if (cacheCookieHelper) {
      cacheCookieHelper.setCacheCookie();
    }

    return isFromLogin;
  }

  setPersonalizedData() {
    personalizedInfo = JSON.parse(utilities.sessionStorageLoad(config.sessionVariables.header.personalInfo, null));
    currency = this.getCurrencyCookie();
    language = this.getLanguageCookie();
    let personalizationInitPromise = $.Deferred();
    // check to see if the user has changed preferences since last page load
    // if so, hydrate personalized header items, e.g. name, email
    if (!personalizedInfo || this.isPersonalDataStale()) {
      this.getPersonalizedData().then((response) => {
        personalizedInfo = response;
        utilities.sessionStorageSave(config.sessionVariables.header.personalInfo, JSON.stringify(personalizedInfo));
        personalizationInitPromise.resolve(personalizedInfo);
      });
    } else {
      personalizationInitPromise.resolve(personalizedInfo);
    }
    return personalizationInitPromise;
  }

  getPersonalizedData() {
    let userServicePromise = $.Deferred();
    let headerData = {
      currency: {},
      greeting: null
    };
    headerData.hasCompleteCurrencyData = false;
    headerData.currencyString = currency;
    headerData.language = language;

    // if te user is logged in, get the name from the cart service
    if (userIsLoggedIn && !headerData.greeting) {
      var r = this.getUserFirstName();
      headerData.greeting = pluraliseAndTranslate('membership', 'loggedInGreetingText', { name: r });
      userServicePromise.resolve(headerData);
    } else {
      userServicePromise.resolve(headerData);
    }
    return userServicePromise;
  }

  getUserFirstName() {

    var userName = this.resolveUserFirstName();
    if (userName && userName !== '-1') {
      return userName;
    }

    return '';
  }

  resolveUserFirstName() {
    const currentUserFirstName = $.trim(window.localStorage.currentUserFirstName);
    const currentUserDisplayFirstName = $.trim(Arrow.currentUserDisplayName).split(' ')[0];

    if (currentUserFirstName) {
      const isMismatch = currentUserDisplayFirstName &&
        currentUserDisplayFirstName !== currentUserFirstName;

      if (!isMismatch) {
        return currentUserFirstName;
      }
    }

    if (currentUserDisplayFirstName) {
      this.setCurrentUserFirstName(currentUserDisplayFirstName);
      return currentUserDisplayFirstName;
    }

  }

  setCurrentUserFirstName(firstName) {
    window.localStorage.currentUserFirstName = firstName;
  }

  getAIdCookie() {
    return cookies.get(config.cookies.userFirstName);
  }

  getCurrencyCookie() {
    return cookies.get(config.cookies.currency);
  }

  getLanguageCookie() {
    return cookies.get(config.cookies.arrowLanguage);
  }

  getFedCookie() {
    return cookies.get(config.cookies.arrowFed);
  }

  isPersonalDataStale() {
    // check to see whether the language, currency or if the user is now authenticated
    // if any of those things change, we need to update local cache
    var defaultTranslation = pluraliseAndTranslate('membership', 'loggedInGreetingText', { name: '' });
    return personalizedInfo.language !== language
      || personalizedInfo.currencyString !== currency
      || (userIsLoggedIn && (!personalizedInfo.greeting) && personalizedInfo.greeting !== defaultTranslation);
  }

}

export function create($parent) {
  if ($parent.find('header.head').length && !headerInstance) {
    $global.setHeader();
    headerInstance = new Header();
    headerInstance.initialize();
  }
}



// WEBPACK FOOTER //
// ./assets/components/Header/Header.js